import { render, staticRenderFns } from "./grossing-touch-subportion-sidepanel.vue?vue&type=template&id=ca4f094a&"
import script from "./grossing-touch-subportion-sidepanel.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-subportion-sidepanel.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports